export function _killPropagation(e?: React.MouseEvent<any, any>) {
  e?.preventDefault()
  e?.stopPropagation()
  e?.nativeEvent.stopImmediatePropagation()
}
